import { mdiHelpCircleOutline } from "@mdi/js";
import Icon from "@mdi/react";
import React, { FunctionComponent } from "react";

import { IconProps } from "@mdi/react/dist/IconProps";
import {
  AppDeniedSVGIcon,
  AppSuccessSVGIcon,
  BidAwardedSVGIcon,
  BidPlacedSVGIcon,
  BidReceivedSVGIcon,
  BidRetractedSVGIcon,
  CarrierPaidSVGIcon,
  CreditApprovedSVGIcon,
  CreditNeedsReviewSVGIcon,
  CrisisManagementSvgIcon,
  DeclinedPrSVGIcon,
  DocumentIssueSVGIcon,
  FactoringWelcomeSVGIcon,
  FrPaidSVGIcon,
  HaulpayFactoringSVGIcon,
  IncompleteFrSVGIcon,
  InvoicePaidSVGIcon,
  InvoicingPendingSVGIcon,
  LoadBidSVGIcon,
  LoadDeclinedSVGIcon,
  LoadMatchSVGIcon,
  LoadPaidSVGIcon,
  LoadStatusCancelledSVGIcon,
  LoadStatusCompletedSVGIcon,
  LoadStatusDeliveringSVGIcon,
  LoadStatusDispatchedSVGIcon,
  LoadStatusInTransitSVGIcon,
  LoadStatusPickedUpSVGIcon,
  LoadStatusRateConfirmedSVGIcon,
  NewLoadAssignedSVGIcon,
  NewResponseSVGIcon,
  OfflineBoltSVGIcon,
  PaymentRequestSVGIcon,
  PendingOriginalsSVGIcon,
  QuestionSVGIcon,
  SettingsSVGIcon,
  ShipperLoadSVGIcon,
  TruckMatchSVGIcon,
  UnderBidAlertSVGIcon,
  WelcomeSVGIcon
} from "components/SVGIcons";
import { INotificationType, IStatusCard, IWalletBalance } from "models/Home";
import { routes } from "./routes";

export const HOME_NOTIFICATION_TYPES: INotificationType[] = [
  {
    id: 0,
    item_type: "other",
    title: "Other",
    icon: (props: FunctionComponent<IconProps>) => <Icon path={mdiHelpCircleOutline} {...props} />
  },
  {
    id: 1,
    item_type: "shipper_alert",
    title: "New Shipper Load Posted.",
    icon: (props: React.SVGProps<SVGSVGElement>) => <ShipperLoadSVGIcon {...props} />
  },
  {
    id: 2,
    item_type: "factoring_funding_request_created",
    title: "Your Payment Request is Received.",
    icon: (props: React.SVGProps<SVGSVGElement>) => <PaymentRequestSVGIcon {...props} />
  },
  {
    id: 3,
    item_type: "factoring_funding_request_incomplete",
    title: "Your recent funding request is incomplete. Tap here to finish it",
    icon: (props: React.SVGProps<SVGSVGElement>) => <IncompleteFrSVGIcon {...props} />
  },
  {
    id: 4,
    item_type: "welcome_to_comfreight",
    title: "Welcome to Haulpay!",
    icon: (props: React.SVGProps<SVGSVGElement>) => <WelcomeSVGIcon {...props} />
  },
  {
    id: 5,
    item_type: "factoring_application_approved",
    title: "Approved for Haul Pay Factoring!",
    icon: (props: React.SVGProps<SVGSVGElement>) => <HaulpayFactoringSVGIcon {...props} />
  },
  {
    id: 6,
    item_type: "factoring_linked_debtor_declined",
    title: "Invoice Payment Request Declined.",
    icon: (props: React.SVGProps<SVGSVGElement>) => <DeclinedPrSVGIcon {...props} />
  },
  {
    id: 7,
    item_type: "my_load_bid_received",
    title: "New Bid on Your Load",
    icon: (props: React.SVGProps<SVGSVGElement>) => <BidReceivedSVGIcon {...props} />
  },
  {
    id: 8,
    item_type: "my_load_truck_match",
    title: "Truck Match to Your Load",
    icon: (props: React.SVGProps<SVGSVGElement>) => <TruckMatchSVGIcon {...props} />
  },
  {
    id: 9,
    item_type: "my_load_bid_awarded",
    title: "You Awarded a Bid on Your Load",
    icon: (props: React.SVGProps<SVGSVGElement>) => <BidAwardedSVGIcon {...props} />
  },
  {
    id: 10,
    item_type: "my_truck_load_match",
    title: "Load Match to Your Truck",
    icon: (props: React.SVGProps<SVGSVGElement>) => <LoadMatchSVGIcon {...props} />
  },
  {
    id: 11,
    item_type: "my_bid_awarded",
    title: "You Have Been Awarded Your Bid",
    icon: (props: React.SVGProps<SVGSVGElement>) => <BidAwardedSVGIcon {...props} />
  },
  {
    id: 12,
    item_type: "bid_placed",
    title: "You Placed a Bid",
    icon: (props: React.SVGProps<SVGSVGElement>) => <BidPlacedSVGIcon {...props} />
  },
  {
    id: 13,
    item_type: "bid_retracted",
    title: "You Retracted a Bid",
    icon: (props: React.SVGProps<SVGSVGElement>) => <BidRetractedSVGIcon {...props} />
  },
  {
    id: 14,
    item_type: "my_load_bid_retracted",
    title: "A Bid on Your Load Has Been Retracted",
    icon: (props: React.SVGProps<SVGSVGElement>) => <LoadBidSVGIcon {...props} />
  },
  {
    id: 15,
    item_type: "underbid_alert",
    title: "You Have Been Under-Bid",
    icon: (props: React.SVGProps<SVGSVGElement>) => <UnderBidAlertSVGIcon {...props} />
  },
  {
    id: 16,
    item_type: "my_load_question",
    title: "New Question on Your Load",
    icon: (props: React.SVGProps<SVGSVGElement>) => <QuestionSVGIcon {...props} />
  },
  {
    id: 17,
    item_type: "my_truck_question",
    title: "New Question on Your Truck",
    icon: (props: React.SVGProps<SVGSVGElement>) => <QuestionSVGIcon {...props} />
  },
  {
    id: 18,
    item_type: "my_question_answer_load",
    title: "New Response to Your Question",
    icon: (props: React.SVGProps<SVGSVGElement>) => <NewResponseSVGIcon {...props} />
  },
  {
    id: 19,
    item_type: "my_question_answer_truck",
    title: "New Response to Your Question",
    icon: (props: React.SVGProps<SVGSVGElement>) => <NewResponseSVGIcon {...props} />
  },
  {
    id: 20,
    item_type: "factoring_welcome",
    title: "Want the fastest payments on all of your hauls?",
    icon: (props: React.SVGProps<SVGSVGElement>) => <FactoringWelcomeSVGIcon {...props} />
  },
  {
    id: 21,
    item_type: "factoring_application_pending",
    title: "Haul Pay Factoring Application: SUCCESS",
    icon: (props: React.SVGProps<SVGSVGElement>) => <AppSuccessSVGIcon {...props} />
  },
  {
    id: 22,
    item_type: "factoring_application_denied",
    title: "Haul Pay Factoring Application Not Approved",
    icon: (props: React.SVGProps<SVGSVGElement>) => <AppDeniedSVGIcon {...props} />
  },
  {
    id: 23,
    item_type: "factoring_linked_debtor_approved",
    title: "New Customer Credit Approval",
    icon: (props: React.SVGProps<SVGSVGElement>) => <CreditApprovedSVGIcon {...props} />
  },
  {
    id: 24,
    item_type: "factoring_linked_debtor_needs_review",
    title: "New Customer Credit Needs Review",
    icon: (props: React.SVGProps<SVGSVGElement>) => <CreditNeedsReviewSVGIcon {...props} />
  },
  {
    id: 25,
    item_type: "load_post_trip_update_rate_confirmed",
    title: "New Status For Load Set to Rate Confirmed",
    icon: (props: React.SVGProps<SVGSVGElement>) => <LoadStatusRateConfirmedSVGIcon {...props} />
  },
  {
    id: 26,
    item_type: "load_post_trip_update_dispatched",
    title: "New Status For Load Set to Dispatched",
    icon: (props: React.SVGProps<SVGSVGElement>) => <LoadStatusDispatchedSVGIcon {...props} />
  },
  {
    id: 27,
    item_type: "load_post_trip_update_picking_up",
    title: "New Status For Load Set to Picking Up",
    icon: (props: React.SVGProps<SVGSVGElement>) => <LoadStatusPickedUpSVGIcon {...props} />
  },
  {
    id: 28,
    item_type: "load_post_trip_update_in_transit",
    title: "New Status For Load Set to In Transit",
    icon: (props: React.SVGProps<SVGSVGElement>) => <LoadStatusInTransitSVGIcon {...props} />
  },
  {
    id: 29,
    item_type: "load_post_trip_update_delivering",
    title: "New Status For Load Set to Delivering",
    icon: (props: React.SVGProps<SVGSVGElement>) => <LoadStatusDeliveringSVGIcon {...props} />
  },
  {
    id: 30,
    item_type: "load_post_trip_update_completed",
    title: "New Status For Load Set to Completed",
    icon: (props: React.SVGProps<SVGSVGElement>) => <LoadStatusCompletedSVGIcon {...props} />
  },
  {
    id: 31,
    item_type: "load_post_trip_update_cancelled",
    title: "New Status For Load Set to Cancelled",
    icon: (props: React.SVGProps<SVGSVGElement>) => <LoadStatusCancelledSVGIcon {...props} />
  },
  {
    id: 32,
    item_type: "factoring_funding_request_paid",
    title: "Invoice Payment Request Status: PAID",
    icon: (props: React.SVGProps<SVGSVGElement>) => <FrPaidSVGIcon {...props} />
  },
  {
    id: 33,
    item_type: "factoring_funding_request_declined",
    title: "Invoice Payment Request DECLINED",
    icon: (props: React.SVGProps<SVGSVGElement>) => <DeclinedPrSVGIcon {...props} />
  },
  {
    id: 34,
    item_type: "factoring_funding_request_approved",
    title: "Your Payment Request is APPROVED",
    icon: (props: React.SVGProps<SVGSVGElement>) => <FrPaidSVGIcon {...props} />
  },
  {
    id: 35,
    item_type: "factoring_funding_request_load_delivered",
    title: "Load Delivered: Invoicing Pending",
    icon: (props: React.SVGProps<SVGSVGElement>) => <InvoicingPendingSVGIcon {...props} />
  },
  {
    id: 36,
    item_type: "factoring_funding_request_pending_originals",
    title: "Payment Status: Pending Originals",
    icon: (props: React.SVGProps<SVGSVGElement>) => <PendingOriginalsSVGIcon {...props} />
  },
  {
    id: 37,
    item_type: "factoring_funding_request_document_issue",
    title: "ATTENTION: Document Issue on Payment Request",
    icon: (props: React.SVGProps<SVGSVGElement>) => <DocumentIssueSVGIcon {...props} />
  },
  {
    id: 38,
    item_type: "factoring_funding_request_carrier_paid",
    title: "Invoice Payment Request Status: Carrier Paid",
    icon: (props: React.SVGProps<SVGSVGElement>) => <CarrierPaidSVGIcon {...props} />
  },
  {
    id: 39,
    item_type: "factoring_funding_request_debtor_paid",
    title: "Invoice payment request Status: Invoice Paid",
    icon: (props: React.SVGProps<SVGSVGElement>) => <InvoicePaidSVGIcon {...props} />
  },
  {
    id: 40,
    item_type: "assigned_to_load",
    title: "New load has been assigned",
    icon: (props: React.SVGProps<SVGSVGElement>) => <NewLoadAssignedSVGIcon {...props} />
  },
  {
    id: 41,
    item_type: "assigned_load_paid",
    title: "Assigned Load Status: PAID",
    icon: (props: React.SVGProps<SVGSVGElement>) => <LoadPaidSVGIcon {...props} />
  },
  {
    id: 42,
    item_type: "assigned_load_declined",
    title: "Assigned Load DECLINED",
    icon: (props: React.SVGProps<SVGSVGElement>) => <LoadDeclinedSVGIcon {...props} />
  }
];

export const INITIAL_STATUS_CARD: IStatusCard[] = [
  {
    id: 0,
    title: "Faster Pay",
    content: "Say goodbye to payment delays",
    icon: (props: React.SVGProps<SVGSVGElement>) => <OfflineBoltSVGIcon {...props} />
  },
  {
    id: 1,
    title: "Reduce Risk",
    content: "Eliminate most payment risk overnight",
    icon: (props: React.SVGProps<SVGSVGElement>) => <CrisisManagementSvgIcon {...props} />
  },
  {
    id: 2,
    title: "Automate Workflows",
    content: "Get more of your time back",
    icon: (props: React.SVGProps<SVGSVGElement>) => <SettingsSVGIcon {...props} />
  }
];

export const WALLET_BALANCE_LIST: IWalletBalance[] = [
  {
    id: 0,
    title: "Wallet Balance",
    value: "show_wallet_balance",
    balanceKey: "balance",
    detailPath: routes.HAULPAY_BROKER_WALLET,
    show: true,
    showButton: true
  },
  {
    id: 1,
    title: "Reserve Balance",
    value: "show_reserve_balance",
    show: false,
    showButton: false
  },
  {
    id: 2,
    title: "Pending Amount",
    value: "show_pending_amount",
    balanceKey: "pending",
    detailPath: routes.HAULPAY_BROKER_WALLET_PENDING,
    show: true,
    showButton: false
  },
  {
    id: 3,
    title: "24 Hours approved $ amount",
    value: "show_24_hours_approved_amount",
    show: false,
    showButton: false
  },
  {
    id: 4,
    title: "Loads pending admin approval",
    value: "show_load_pending_admin_amount",
    show: false,
    showButton: false
  },
  {
    id: 5,
    title: "Accounts receivable balance",
    value: "show_accounts_receivables_balance",
    show: false,
    showButton: false
  }
];

export const isSupportedWalletBalanceCard = (
  card: IWalletBalance
): card is IWalletBalance & Required<Pick<IWalletBalance, "balanceKey" | "detailPath">> =>
  Boolean(card.balanceKey && card.detailPath);

export const NOTIFICATION_FILTER_ITEM = [
  {
    id: 0,
    label: "All Activity",
    value: ""
  },
  {
    id: 1,
    label: "Bids Placed",
    value: "bid_placed"
  },
  {
    id: 2,
    label: "Bids Received",
    value: "my_load_bid_received"
  },
  {
    id: 3,
    label: "Bids Awarded",
    value: "my_bid_awarded,my_load_bid_awarded"
  },
  {
    id: 4,
    label: "Bids Retracted",
    value: "bid_retracted,my_load_bid_retracted"
  },
  {
    id: 5,
    label: "Under-Bid Alert",
    value: "underbid_alert"
  },
  {
    id: 6,
    label: "Load Matches",
    value: "my_truck_load_match"
  },
  {
    id: 7,
    label: "Truck Matches",
    value: "my_load_truck_match"
  },
  {
    id: 8,
    label: "Shipper Load",
    value: "shipper_alert"
  },
  {
    id: 9,
    label: "Question",
    value: "my_load_question,my_truck_question"
  },
  {
    id: 10,
    label: "Answer",
    value: "my_load_answer,my_truck_answer"
  }
];

export const AVAILABLE_SAVED_POSTS = {
  posts: {
    label: "Saved Posts",
    link: routes.SAVED_POSTS
  },
  loads: {
    label: "Saved Loads",
    link: routes.SAVED_LOADS
  },
  trucks: {
    label: "Saved Trucks",
    link: routes.SAVED_TRUCKS
  }
};
